import './SelectionButton.css';
import { useState } from 'react';

function SelectionButton (props) {

    const [isClicked, setIsClicked] = useState(false)

    function handleClick() {
        setIsClicked(!isClicked);
        props.onClickFunction();
    }

    return (
        <div>
            <button className={isClicked ? 'selection-button-selected' : 'selection-button'} onClick={handleClick}>{props.buttonText}</button>
        </div>
    )
}

export default SelectionButton;